import{commonjsGlobal as e}from"../../_virtual/_commonjsHelpers.js";var t="object"==typeof e&&e&&e.Object===Object&&e;export{t as default};
//# sourceMappingURL=_freeGlobal.js.map
